import { buildApiUrl, authFetch } from '@/config/api';
import type { WorkItem, CreateWorkItemInput, UpdateWorkItemInput, WorkItemStatus } from '@/types/workItem';

export async function listWorkItems(params?: {
  channelId?: string;
  ownerUserId?: string;
  status?: WorkItemStatus;
}): Promise<WorkItem[]> {
  const url = new URL(buildApiUrl('/api/workitems'), window.location.origin);
  if (params?.channelId) url.searchParams.set('channelId', params.channelId);
  if (params?.ownerUserId) url.searchParams.set('ownerUserId', params.ownerUserId);
  if (params?.status) url.searchParams.set('status', params.status);

  const response = await authFetch(url.toString());
  if (!response.ok) throw new Error('Failed to fetch work items');
  return response.json();
}

export async function getWorkItem(id: string): Promise<WorkItem> {
  const response = await authFetch(buildApiUrl(`/api/workitems/${id}`));
  if (!response.ok) throw new Error('Failed to fetch work item');
  return response.json();
}

export async function createWorkItem(input: CreateWorkItemInput): Promise<WorkItem> {
  const response = await authFetch(buildApiUrl('/api/workitems'), {
    method: 'POST',
    body: JSON.stringify(input),
  });
  if (!response.ok) throw new Error('Failed to create work item');
  return response.json();
}

export async function updateWorkItem(id: string, input: UpdateWorkItemInput): Promise<WorkItem> {
  const response = await authFetch(buildApiUrl(`/api/workitems/${id}`), {
    method: 'PATCH',
    body: JSON.stringify(input),
  });
  if (!response.ok) throw new Error('Failed to update work item');
  return response.json();
}

export async function deleteWorkItem(id: string): Promise<void> {
  const response = await authFetch(buildApiUrl(`/api/workitems/${id}`), { method: 'DELETE' });
  if (!response.ok) throw new Error('Failed to delete work item');
}
